'use strict';

var _classCallCheck = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/orie/OR13/G0/node_modules/@babel/runtime/helpers/createClass");

var DocumentIndex =
/*#__PURE__*/
function () {
  function DocumentIndex() {
    _classCallCheck(this, DocumentIndex);

    this._index = {};
  }

  _createClass(DocumentIndex, [{
    key: "get",
    value: function get(key) {
      var fullOp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return fullOp ? this._index[key] : this._index[key] ? this._index[key].payload.value : null;
    }
  }, {
    key: "updateIndex",
    value: function updateIndex(oplog, onProgressCallback) {
      var _this = this;

      var reducer = function reducer(handled, item, idx) {
        if (handled[item.payload.key] !== true) {
          handled[item.payload.key] = true;

          if (item.payload.op === 'PUT') {
            _this._index[item.payload.key] = item;
          } else if (item.payload.op === 'DEL') {
            delete _this._index[item.payload.key];
          }
        }

        if (onProgressCallback) onProgressCallback(item, idx);
        return handled;
      };

      oplog.values.slice().reverse().reduce(reducer, {});
    }
  }]);

  return DocumentIndex;
}();

module.exports = DocumentIndex;